import React, { useEffect, useState } from "react";
import { Line } from "rc-progress";
import { parentToolsModal } from "../../redux/actions";
import { useDispatch } from "react-redux";
const TabingPopup = ({ tabCount, setTabCount, handleTab }) => {
    const dispatch = useDispatch();
    const closePopUp = () => {
        dispatch(parentToolsModal());
    }
    const handleCount = (count) => {
        if (count >= 1 && count <= 3) {
            setTabCount(count);
        }
    }
    const getPercant = 100/3 *  tabCount;
    return (
        <div class="mytoottiptxt p-3">
            <div className="nextbackicons flexone mb-3">
                <span className="nxtbckicon" onClick={()=>handleCount(tabCount-1)}>
                    <i class="fa-thin fa-circle-arrow-left"></i>
                </span>
                <span className="text-center mytabprogress">
                    <span className="mysteps"> Step {tabCount}/3</span>
                    <Line percent={getPercant} strokeWidth={1.5} strokeColor={"#1ec1d9"} />
                </span>
                <span className="nxtbckicon" onClick={()=>handleCount(tabCount+1)}>
                    <i class="fa-thin fa-circle-arrow-right"></i>
                </span>
            
            </div>
            {
                tabCount === 1 && (
                    <>
                    <p class="p1 mb-1 fw-700">Struggling With Essential Life Skills?</p>
                    <p class="p2 mb-3">You can browse and choose any course you feel fits your child best—because no one knows them better than you do.</p>
                    <p className="text-right">
                        <button className="mybutton" onClick={()=>closePopUp()}>Skip Tour</button>
                    </p>
                    </>
                )
            }
            {
                tabCount === 2 && (
                    <>
                    <p class="p1 mb-1 fw-700">Looking For Help With Life Events?</p>
                    <p class="p2 mb-3">Choose a life event your child is facing, and we’ll recommend expert-backed plans and courses to help them move forward.</p>
                    <p className="text-right">
                        <button className="mybutton" onClick={()=>closePopUp()}>Skip Tour</button>
                    </p>
                    </>
                )
            }
            {
                tabCount === 3 && (
                    <>
                    <p class="p1 mb-1 fw-700">Trying To Overcome Life Challenges?</p>
                    <p class="p2 mb-3">Select the challenges your child is experiencing, and we’ll guide you to the best plan to build the skills they need.</p>
                    <p className="text-right">
                        <button className="mybutton" onClick={()=>closePopUp()}>Finish</button>
                    </p>
                    </>
                )
            }     
        </div>    
    )
}
export default TabingPopup;